import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";

import Layout from "app/components/layouts";

import PartOne from "app/components/Individual/assetsLiabilities/PartOne";
import PartTwo from "app/components/Individual/assetsLiabilities/PartTwo";
import PartThree from "app/components/Individual/assetsLiabilities/PartThree";
import PartFour from "app/components/Individual/assetsLiabilities/PartFour";
import PartFive from "app/components/Individual/assetsLiabilities/PartFive";
import PartSix from "app/components/Individual/assetsLiabilities/PartSix";
import PartSeven from "app/components/Individual/assetsLiabilities/PartSeven";
import PartEighth from "app/components/Individual/assetsLiabilities/PartEighth";
import CarLoan from "app/components/Individual/assetsLiabilities/CarLoan";

import LoanTypeStepper from "app/components/common/LoanTypeStepper";

const AssetsLiabilities: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.assetsLiabilities.currentStep
  );
  const personalDetailsData = useSelector(
    (state: RootState) => state.personalDetails.stepsData.formFour
  );

  const steps =
    personalDetailsData?.visaStatus === "Citizen"
      ? [
          <PartOne key="assets-partone" />,
          <PartTwo key="assets-PartTwo" />,
          <PartThree key="assets-part-three" />,
          <CarLoan key="assets-car-loan" />,
          <PartFour key="assets-part-four" />,
          <PartFive key="assets-part-five" />, // Step 5: Upload passport image
          <PartSix key="assets-part-six" />, // Step 6: Upload driver license
          <PartSeven key="assets-part-seven" />, // Step 7: Connect Bank
        ]
      : [
          <PartOne key="assets-partone" />,
          <PartTwo key="assets-part-two" />,
          <PartThree key="assets-part-two" />,
          <CarLoan key="assets-car-loan" />,
          <PartFour key="assets-part-four" />,
          <PartEighth progressValue={60} key="assets-part-eight" />, // Step 5  Upload passport & visa image
          <PartSix key="assets-part-six" />, // Step 6  Upload driver license
          <PartSeven key="assets-part-seven" />, // Step 7 Connect Bank
        ];

  return (
    <>
      <Layout>
        <LoanTypeStepper />
        {steps[currentStep - 1] ?? <PartOne />}
      </Layout>
    </>
  );
};

export default AssetsLiabilities;
